var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-line",class:[{'darker': _vm.darker, 'is-vertical': _vm.orientation === 'vertical'}, _vm.getMarginSize()]})}
var staticRenderFns = []

export { render, staticRenderFns }